import SmartPricingColor from './SmartPricingColour.svg';
import SmartPricingDark from './SmartPricingDark.svg';
import SmartPricingLight from './SmartPricingLight.svg';
export const smartPricing = { color: SmartPricingColor, dark: SmartPricingDark, light: SmartPricingLight };
//# sourceMappingURL=index.js.map